import { Typography, Box, Container, Grid2, useTheme } from "@mui/material";
import React from "react";
import styles from "./TrendProduct.module.css";
import { useNavigate } from "react-router-dom";

const TrendProduct = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isLight = theme.palette.mode === "light";

  const containerStyles = {
    "--card-bg": isLight ? "rgba(255, 255, 255, 0.9)" : "#1A1F2B",
    "--card-border": isLight ? "rgba(0, 0, 0, 0.05)" : "rgba(0, 255, 255, 0.15)",
    "--card-shadow": isLight ? "0 4px 20px rgba(0, 0, 0, 0.05)" : "0 0 20px rgba(0, 255, 255, 0.05)",
    "--card-hover-border": isLight ? "rgba(0, 0, 0, 0.1)" : "rgba(0, 255, 255, 0.5)",
    "--card-hover-shadow": isLight ? "0 8px 25px rgba(0, 0, 0, 0.1)" : "0 0 30px rgba(0, 255, 255, 0.15)",
    "--card-hover-bg": isLight ? "#ffffff" : "#1A222C",
    "--text-primary": isLight ? "#0f172a" : "#fff",
    "--text-secondary": isLight ? "#475569" : "#94A3B8",
    "--btn-bg": isLight ? "#2299b7" : "var(--bg, linear-gradient(226deg, #2299b7 -39.46%, #0a0b2a 94.74%))",
    "--btn-text": "#fff",
    "--check-color": "#2299b7",
  };

  const products = [
    {
      id: 1,
      image: "/images/trendweb.png",
      title: "TrendifyWeb",
      subtitle: "AI-Powered Website Builder",
      features: [
        "Advanced AI orchestration",
        "State-of-the-art templates",
        "One-click deployment"
      ],
      btnText: "Learn More",
      path: "https://trendifyweb.ai/",
    },
    {
      id: 2,
      image: "/images/trendifytokens.png",
      title: "Trendify Token",
      subtitle: "Empowering Next-Gen Innovations",
      features: [
        "Gateway to Future of Crypto",
        "Advanced Token Utility",
        "Community Governance"
      ],
      btnText: "Learn More",
      path: "https://trendifytokens.io/",
    },
    {
      id: 3,
      image: "/images/trendads.png", // Using TrendAds as the third product to match context
      title: "TrendAds",
      subtitle: "Smart Advertising Hub",
      features: [
        "Precision ad targeting",
        "Transparent reward system",
        "Real-time analytics"
      ],
      btnText: "Learn More",
      path: "https://trendads.ai/",
    },
  ];

  const handleRedirect = (path) => {
    if (!path) return;
    if (path.startsWith("http")) {
      window.open(path, "_blank");
    } else {
      navigate(path);
    }
  };

  return (
    <Container className={styles.titleContainer} style={containerStyles} maxWidth="lg">
      <Box mt={6} mb={4}>
        <Typography
          variant="h3"
          className={styles.mainTitle}
          sx={{
            fontWeight: 800,
            color: (theme) => theme.palette.text.primary,
            textAlign: "center",
            fontSize: { xs: "1.75rem", md: "2.5rem" }
          }}
        >
          Get <span className={styles.gradientText}>Trend Products</span>
        </Typography>
      </Box>

      <Grid2 container spacing={2} justifyContent="center" alignItems="stretch">
        {products?.map((item, index) => (
          <Grid2
            size={{ xs: 12, sm: 6, md: 4 }}
            key={index}
          >
            <div className={styles.cardWrapper}>
              <div
                className={styles.featureCard}
                onClick={() => handleRedirect(item.path)}
              >
                <div className={styles.imageBox}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className={styles.cardImage}
                  />
                </div>

                <div className={styles.contentBox}>
                  <h3 className={styles.cardTitle}>{item.title}</h3>
                  <p className={styles.cardSubtitle}>{item.subtitle}</p>

                  <ul className={styles.featureList}>
                    {item.features.map((feature, i) => (
                      <li key={i} className={styles.featureItem}>
                        <svg className={styles.checkIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5 13L9 17L19 7" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        {feature}
                      </li>
                    ))}
                  </ul>

                  <button
                    className={styles.actionButton}
                    onClick={(e) => {
                      if (!item.path) {
                        e.stopPropagation();
                        return;
                      }
                      handleRedirect(item.path);
                    }}
                    disabled={!item.path}
                  >
                    {item.path ? item.btnText : "Coming Soon"}
                    <svg className={styles.btnArrow} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </Grid2>
        ))}
      </Grid2>

      <Box mt={6} display="flex" justifyContent="center">
        <Typography variant="body2" sx={{ opacity: 0.5 }}>
          Built with institutional precision.
        </Typography>
      </Box>
    </Container>
  );
};

export default TrendProduct;
